export default __webpack_public_path__ + "static/media/report.c0067e70.png";